<template>
  <div style="min-height:500px; min-width:1200px">
    <div class="ZMSeparatoreScheda" style="margin-bottom:10px;margin-top:5px" :style="{'background-color' : ColoriPantone.Marrone }">       
      <text v-if="TipoGrafico == TipologieGrafici.TENSIONE_ALIMENTAZIONE" style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoTensioneAssorbimento','TKN_FRM_GRAF_TENS_TITOLO',this.LinguaUtente) }}</text>
      <text v-if="TipoGrafico == TipologieGrafici.ASSORBIMENTO" style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEFrameComponenteGraficoTensioneAssorbimento','TKN_FRM_GRAF_ASS_TITOLO',this.LinguaUtente) }}</text>
    </div>
    <div style="width:83%;float:left" ref="DivCanvas">
      <VUEComponenteGraficoTensioneAssorbimento :WidthGrafico="GrandezzaCanvas.Width" 
                                                :HeightGrafico="GrandezzaCanvas.Height"
                                                :ListaModuli="ListaModuli"
                                                :ObjDal="ObjDal"
                                                :ObjAl="ObjAl"
                                                :TipoGrafico="TipoGrafico"
                                                :PropsGrafico="ObjGrafico"
                                                :Repaint="Repaint"
                                                :GraficiChange="GraficiChange"/>
    </div>
      
    <div style="width:17%;float:left; border: solid 1px black;margin-top:24px" ref="DivButtons">
      <div style="margin-top:5px;">
        <div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:92%;">
           
            <div style="overflow:auto; max-height: 450px">
              <template v-for="Modulo in ObjGrafico.ListaModuli" :key="Modulo.Id">
                <div style="float:left;width:100%;">
                  <label :style="{'color' : Modulo.Colore}" style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('Generic','TKN_MOD_N',this.LinguaUtente) }} {{ Modulo.NomeModulo }}</label>
                </div> 
                <div style="clear:both;height:3px"></div> 
              </template>
            </div>
            
            <div style="clear:both;height:1px"></div>
          </div>
          <div style="clear:both"></div>
        </div>
      </div>   
      <div style="float:left;">&nbsp;</div>
    </div>
  </div>
  <div style="clear:both"></div>

</template>

<script>
import { COLORI_PANTONE, SystemInformation, TIPOLOGIA_GRAFICI_STORICI } from '@/SystemInformation'
import { TZGenericFunct } from '@/utils/ZGenericFunct.js'
import VUEComponenteGraficoTensioneAssorbimento from './VUEComponenteGraficoTensioneAssorbimento.vue'
import MixInsGraficiStorici from '@/views/ContentPages/MixInsGraficiStorici'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';


export default 
{
  mixins: [ MixInsGestioneTraduzioni, MixInsGraficiStorici ],
  data()
  {
   return {
            ColoriPantone    : COLORI_PANTONE,
            LinguaUtente     : SystemInformation.UserInformation.Lingua,
            OrientamentoAsse : SystemInformation.OggettoInfoGraficiStorici.OrientamentoAsse,
            GrandezzaCanvas  : {
                                  Width  : 0,
                                  Height : 0
                               },
            ObjGrafico       : {
                                AxisY  : {
                                            Min : 0,
                                            Max : 0,
                                            Udm : 0,
                                            Modificato : false,
                                         },
                                },
            Repaint          : 0,
            TipologieGrafici : TIPOLOGIA_GRAFICI_STORICI

          }
  },

  props : [
              'ListaModuli', 
              'ObjDal', 
              'ObjAl', 
              'TipoGrafico', 
              'GraficiChange',
              'ParametriPDF',
              'GetDatiPDF' 
          ],

  emits : ['EsportaPDFGrafico'],

  components: { 
                VUEComponenteGraficoTensioneAssorbimento,
              },

  methods :
  {
    CalcolaGrandezzaDivCanvas()
    {
      this.Repaint++
      this.GrandezzaCanvas.Width  = this.$refs.DivCanvas.clientWidth 
      this.GrandezzaCanvas.Height = 540
    },

    GetGraficiPDF()
    {
      let LsModuli = []
      for (let i = 0; i < this.ListaModuli.length; i++)
      {
        if(this.ListaModuli[i].Disegna)
        {
          let Modulo = TZGenericFunct.GetCopyOfObject(this.ListaModuli[i])
          LsModuli.push(Modulo)
        }
      }
      
      if(!this.ObjPDF.PDFModulo)
        this.ObjPDF.PDFModulo = []

      if(!this.ObjPDF.PDFObjDatiGrafici)
        this.ObjPDF.PDFObjDatiGrafici = []

      this.ObjPDF.PDFModulo.push(LsModuli)
      this.ObjPDF.PDFObjDatiGrafici.push(TZGenericFunct.GetCopyOfObject(this.ObjGrafico.OggettoGrafico))

    }
  },
  
  computed:
  {
    CurrentListaModuli :
    {
      get()
      {
        return this.ListaModuli
      }
    },

    ObjPDF :
    {
      get()
      {
        return this.ParametriPDF
      }
    }
  },

  watch:
  {
    GetDatiPDF :
    {
      handler(NewValue)
      {
        if (NewValue != 0)
          this.GetGraficiPDF()
      }
    }
  },

  mounted()
  {
    this.CalcolaGrandezzaDivCanvas()
  },

  beforeMount()
  {
    this.MixInsSetObjGraficoTensAss(this.ObjGrafico, this.ListaModuli, this.TipoGrafico)
  }
}
</script>